import React, { useState, useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import clsx from 'clsx';
import { PowerBIEmbed } from 'powerbi-client-react';
import { models } from 'powerbi-client';
import { makeStyles } from '@material-ui/core';
import CircularProgress from '@material-ui/core/CircularProgress';
import Snackbar from '../Snackbar';
import { getAdminReport } from '../../requests/api/report';

const useStyles = makeStyles((theme) => ({
  root: {
    height: '85vh',
  },
  rootFullScreen: {
    height: '100vh',
  },
  report: {
    height: '100%',
    borderWidth: '0px',
  },
  title: {
    flexGrow: 1,
  },
  loading: {
    color: theme.palette.primary.main,
  },
  container: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '200px',
  },
}));

const Report = ({ fullScreen, id, userId }) => {
  const { t } = useTranslation();

  const [reportId, setReportId] = useState();
  const [url, setUrl] = useState();
  const [embedToken, setEmbedToken] = useState();
  const [filters, setFilters] = useState();
  const [loading, setLoading] = useState(true);
  const [err, setErr] = useState('');
  const styles = useStyles();

  const userIdRef = useRef(userId);
  userIdRef.current = userId;

  useEffect(() => {
    const parseFilter = (string) => {
      try {
        const parsed = JSON.parse(string);
        setFilters(parsed);
      } catch (e) {
        setErr(t('reports.messages.filterError'));
      }
    };

    const findReport = async () => {
      const response = await getAdminReport(id, userIdRef.current);
      if (response.success) {
        const powerbiData = response.data.data.powerbiReport;
        if (powerbiData.userRelation.configJson) {
          parseFilter(powerbiData.userRelation.configJson);
        }
        setReportId(powerbiData.reportId);
        setUrl(powerbiData.embedUrl);
        setEmbedToken(powerbiData.embedToken);
        setLoading(false);
      } else {
        setErr(response.data.errorMessage);
        setLoading(false);
      }
    };
    findReport();
  }, [id, t]);

  const conditionalRender = () => {
    if (loading) {
      return (
        <div className={styles.container}>
            <CircularProgress className={styles.loading}/>
        </div>
      );
    }
    return (
      <PowerBIEmbed
          embedConfig = {{
            type: 'report', // Supported types: report, dashboard, tile, visual and qna
            id: reportId,
            embedUrl: url,
            accessToken: embedToken,
            tokenType: models.TokenType.Embed,
            filters: Array.isArray(filters) ? filters : [filters].filter(Boolean),
            settings: {
              panes: {
                filters: {
                  expanded: true,
                  visible: false,
                },
              },
            },
          }}
          cssClassName = {
            styles.report
        }
        />
    );
  };
  return (
    <div>
      <div className={clsx({
        [styles.root]: !fullScreen,
        [styles.rootFullScreen]: fullScreen,
      })}>
        {conditionalRender()}
      </div>
      <div>
        <Snackbar
          open={err !== ''}
          message={err}
          severity="error"
          onClose={() => setErr('')}
        />
      </div>
    </div>
  );
};

export default Report;
